import { render, staticRenderFns } from "./TopicWriting.vue?vue&type=template&id=3712c52f&scoped=true&"
import script from "./TopicWriting.vue?vue&type=script&lang=js&"
export * from "./TopicWriting.vue?vue&type=script&lang=js&"
import style0 from "./TopicWriting.vue?vue&type=style&index=0&id=3712c52f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3712c52f",
  null
  
)

export default component.exports